import { browsingApiRoutes as routes } from './routes';
export function getBrowsingApiV1(httpClient) {
    return {
        availability: {
            films: {
                getAll: ()=>httpClient.get(routes.availability.films.getAll())
                ,
                getForFilm: (filmId)=>httpClient.get(routes.availability.films.getForFilm(filmId))
                ,
                getForSite: (siteId)=>httpClient.get(routes.availability.films.getForSite(siteId))
            }
        },
        masterData: {
            events: {
                getAll: ()=>httpClient.get(routes.masterData.events.getAll())
                ,
                getById: (eventId)=>httpClient.get(routes.masterData.events.getById(eventId))
                ,
                getShowtimes: (eventId, query)=>httpClient.get(routes.masterData.events.getShowtimes(eventId), {
                        queryParams: query
                    })
            },
            films: {
                getAll: ()=>httpClient.get(routes.masterData.films.getAll())
                ,
                getForSite: (siteId)=>httpClient.get(routes.masterData.films.getForSite(siteId))
                ,
                getById: (filmId)=>httpClient.get(routes.masterData.films.getById(filmId))
            },
            filmScreeningDates: {
                getAll: (query)=>httpClient.get(routes.masterData.filmScreeningDates.getAll(), {
                        queryParams: query
                    })
            },
            showtimes: {
                getById: (showtimeId)=>httpClient.get(routes.masterData.showtimes.getById(showtimeId))
                ,
                getForBusinessDate: (businessDate, query)=>httpClient.get(routes.masterData.showtimes.getForBusinessDate(businessDate), {
                        queryParams: query
                    })
                ,
                getForFirstBusinessDate: (query)=>httpClient.get(routes.masterData.showtimes.getForFirstBusinessDate(), {
                        queryParams: query
                    })
            },
            sites: {
                getAll: ()=>httpClient.get(routes.masterData.sites.getAll())
                ,
                getById: (siteId)=>httpClient.get(routes.masterData.sites.getById(siteId))
            }
        }
    };
}

//# sourceMappingURL=get-browsing-api.js.map